var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chart-shell',{attrs:{"title":"体位","info":""}},[_c('div',[_c('div',{staticClass:"position-chart",style:({ height: `${_vm.height}px` }),attrs:{"id":"体位"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }